<section class="success-page">
  <div class="success-message">Your message has been sent!</div>
  <div class="link">
    <a href="/messages/inbox">Go to my inbox</a>
  </div>
</section>

<style lang="scss" src="./thankyou.scss">
</style>
